"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
exports.__esModule = true;
var angular = require("angular");
var table_input_logic_1 = require("../table-input2/table-input.logic");
var basic_table_component_1 = require("../basic-component/basic-table.component");
var history_modal_component_1 = require("./history-modal/history-modal.component");
var so_rich_text_box_component_1 = require("../../../components/so-rich-text-box/so-rich-text-box.component");
var inav_utils_service_1 = require("../../../components/utils/inav-utils.service");
var issue_list_1 = require("../../../components/utils/issue-list/issue-list");
require('./gmf-commercial.component.css');
var COMPONENT_NAME = 'smartorg.r6.acts.gmfCommercial';
var COL_CONSTS = { GMF: 6, CU: 7, DELETE: 8 };
var DEFAULT_ROW = { 2: "", 3: "", 4: "", 5: "", 6: 0, 7: 0 };
var GmfCommercialComponent = /** @class */ (function () {
    function GmfCommercialComponent($scope, $timeout, uiGridEditConstants) {
        var _this = this;
        var rootScope = $scope.$root;
        this.$scope = $scope;
        this.showAlert = function (type, title, message) {
            $scope.$emit('workbench:alert', { type: type, title: title, message: message });
        };
        this.reloadData = function () { return $scope.$emit('workbench:reloadAction'); };
        this.utilsService = new inav_utils_service_1.UtilsService(issue_list_1.IssueListEnum.DEFAULT);
        this.lastUpdated = function () { return $scope.$emit('workbench:last_updated', { nodeID: _this.node._id }); };
        this.updateNodeIsDataValid = function () { return $scope.$emit('workbench:update_isDataValid', {
            nodeIdList: [_this.node._id],
            isDataValid: _this.isCommonData !== 'true'
        }); };
        this.setGlobalDirty = function (dirty) {
            rootScope.smartorgDirty = dirty;
        };
        $scope.$on('command:GMF_COMMERCIAL_EXPENSE', function (event, args) {
            _this.loading = true;
            _this.cleanup();
            $timeout(function () {
                try {
                    _this.loadMultipleTables(args, uiGridEditConstants);
                    _this.menu = _this.getMenu();
                }
                catch (err) {
                    _this.showAlert('danger', "Error!", err);
                }
                finally {
                    _this.loading = false;
                }
            });
        });
    }
    GmfCommercialComponent.prototype.$onDestroy = function () {
        this.destroyed = true;
    };
    GmfCommercialComponent.prototype.loadMultipleTables = function (args, uiGridEditConstants) {
        var commonData = args.commonData, readOnly = args.readOnly, actionMenuItem = args.actionMenuItem, data = args.config.data;
        this.username = data.user;
        this.readonly = readOnly;
        this.isMultiple = true;
        this.justCalculated = false;
        this.tablesData = [];
        this.gotDirty = false;
        this.filterAppliedCols = [];
        this.hotTables = [];
        this.summaryColHeaders = ["Node", "Base Year", "Major Activities", "Type of Activity", "Who", "Due By", "Global Marketing Funds (thousand $)", "Commercial Expenses CU (thousand $)"];
        this.configData = { data: [], originData: [] };
        if (commonData) {
            var nodeID = data.nodeID, nodeName = data.nodeName, tableDefn = data.tableDefn;
            this.tableDef = tableDefn[0];
            var _a = this.tableDef, Inherited = _a.Inherited, InputType = _a.InputType;
            this.tableDef.Inherited = Inherited && InputType === 'INHERITED';
            this.node = { _id: nodeID, name: nodeName };
            this.initComments(this.tableDef.Comment);
            this.tableInput = new table_input_logic_1["default"](this.node, this.tableDef, null, null);
            this.gridOptions = this.tableInput.getGridOptions(this.readonly, uiGridEditConstants, this.showAlert);
        }
        else {
            var node = args.node, compareToNode = args.compareToNode;
            this.node = node;
            var totalGmfSummation_1 = [];
            data.data.map(function (nodeData) {
                var baseYear = nodeData.main.tableDef[0].Val.ColHeaders[0];
                var nodeName = nodeData.main.nodeName;
                var dataTemp = nodeData.main.gmfSummation.slice();
                if (dataTemp.length > 0) {
                    dataTemp = dataTemp.map(function (dt) {
                        if (Object.keys(dt).length > 0) {
                            var newElements = { 0: nodeName, 1: baseYear };
                            return __assign({}, newElements, Object.fromEntries(Object.entries(dt).map(function (_a) {
                                var key = _a[0], value = _a[1];
                                return [parseInt(key) + 2, value];
                            })));
                        }
                    });
                }
                else {
                    dataTemp.push(__assign({ 0: nodeName, 1: baseYear }, DEFAULT_ROW));
                }
                totalGmfSummation_1 = totalGmfSummation_1.concat(dataTemp);
            });
            var _b = data.data[0], main = _b.main, sibling = _b.sibling, settings = _b.settings;
            if (!this.verifyTemplateAndNode(main, sibling)) {
                return;
            }
            this.readonly = this.readonly || main.readOnly;
            this.tableDef = main.tableDef[0];
            this.tableDef2 = main.tableDef[1];
            var mainTable = main.tableDef[0];
            var mainTable2 = main.tableDef[1];
            var siblingTable = sibling ? sibling.tableDef : null;
            this.initComments(this.tableDef.Comment);
            this.title = actionMenuItem + " for " + node.name;
            this.tableInput = new table_input_logic_1["default"](node, mainTable, compareToNode, siblingTable);
            this.tableInput2 = new table_input_logic_1["default"](node, mainTable2, compareToNode, siblingTable);
            this.gridOptions = this.tableInput.getGridOptions(this.readonly, uiGridEditConstants, this.showAlert);
            var mainReference = main.referenceData;
            var siblingReference = sibling ? sibling.referenceData : {};
            var decimals = basic_table_component_1.loadSettings(args.treeName, settings).decimals;
            this.referenceData = table_input_logic_1.getReferenceData(mainReference, siblingReference, decimals);
            this.configData = { data: totalGmfSummation_1, originData: angular.copy(totalGmfSummation_1) };
            this.showSummation();
        }
        this.commentDisabled = (this.isCommonData && this.tableDef.InputType === 'INHERITED') ||
            (!this.isCommonData && this.tableDef.Inherited);
    };
    GmfCommercialComponent.prototype.decode = function (string) {
        try {
            return decodeURIComponent(string);
        }
        catch (e) {
            return string;
        }
    };
    GmfCommercialComponent.prototype.initComments = function (comments) {
        this.commentHistory = comments;
        if (this.commentHistory && this.commentHistory.length > 0) {
            var _a = this.commentHistory[this.commentHistory.length - 1], SavedBy = _a.SavedBy, SavedOn = _a.SavedOn, msg = _a.msg, universalTableComment = _a.universalTableComment;
            var decodedMsg = this.decode(msg);
            this.currentComment = {
                savedBy: SavedBy,
                savedOn: SavedOn,
                msg: decodedMsg,
                originMsg: decodedMsg,
                universalTableComment: universalTableComment
            };
        }
        else {
            this.currentComment = { msg: '', originMsg: '', universalTableComment: '' };
        }
    };
    GmfCommercialComponent.prototype.cleanup = function () {
        if (this.tableInput && this.tableInput.onDestroy) {
            this.tableInput.onDestroy();
        }
        this.tableInput = {};
        this.errMessage = null;
        this.commentHistory = null;
        this.currentComment = { msg: '', originMsg: '' };
        this.tableDef = null;
        this.isMultiple = false;
        this.title = '';
        this.saving = false;
        document.getElementById("handson-area").innerHTML = "";
        document.getElementById("handson-gmf-summary").innerHTML = "";
        document.getElementById("handson-gmf-summation").innerHTML = "";
        if (this.gridOptions) {
            this.gridOptions = null;
        }
    };
    GmfCommercialComponent.prototype.verifyTemplateAndNode = function (main, sibling) {
        if (!main || !sibling) {
            this.errMessage = null;
            return true;
        }
        if (main.leafOrPlatform !== sibling.leafOrPlatform) {
            var nodeTypeStr = main.leafOrPlatform === 'leaf' ? 'basic' : 'platform';
            this.errMessage = 'Compare Inputs are only available for the same kind of nodes. ' +
                ("The selected node is a " + nodeTypeStr + " node, ") +
                ("it can only be compared with another " + nodeTypeStr + " node.");
            return false;
        }
        if (main.template !== sibling.template) {
            this.errMessage = 'Compare Table Inputs are only available for ' +
                'the same templates. ' +
                'Selected nodes are using different templates. ';
            return false;
        }
        return true;
    };
    GmfCommercialComponent.prototype.override = function () {
        this.overrideInput({
            targetNodeId: this.node._id,
            sourceNodeId: this.tableDef.rootID,
            inputKey: this.tableDef.Key
        });
    };
    GmfCommercialComponent.prototype.showIt = function (dataGot, divGot, originDataGot) {
        var data = dataGot.Val.Data;
        var originData = originDataGot.Val.Data;
        var colHeaders = dataGot.Val.ColHeaders;
        colHeaders = colHeaders.map(function (c) {
            c = { type: "numeric" };
            return c;
        });
        var ctrl = this;
        var container = document.getElementById(divGot);
        var hot = new Handsontable(container, {
            data: data,
            columns: colHeaders,
            rowHeaders: dataGot.Val.RowHeaders,
            colHeaders: dataGot.Val.ColHeaders,
            sortIndicator: true,
            filters: true,
            cells: function (row, col, prop) {
                var cellProperties = {};
                if (col === 0 && divGot == "CUnGMFTable") { // first column
                    cellProperties.readOnly = true;
                }
                return cellProperties;
            },
            dropdownMenu: [
                "filter_by_value",
                "filter_action_bar",
                "filter_by_condition",
            ],
            stretchH: "all",
            height: "auto",
            // width: "100%",
            rowHeaderWidth: 250,
            licenseKey: ctrl.smartorg.handsonTableLicenseKey,
            beforeChange: function (changes, source) {
                var numericRegex = /^-?\d+(\.\d+)?$/;
                for (var i = 0; i < changes.length; i++) {
                    var row = changes[i][0];
                    var col = changes[i][1];
                    var oldValue = changes[i][2];
                    var newValue = changes[i][3];
                    // If the new value is not a number, set it to 0
                    if (!numericRegex.test(newValue)) {
                        changes[i][3] = 0;
                    }
                }
            },
            afterChange: function (changes, source) {
                if (source === 'edit') {
                    for (var i = 0; i < changes.length; i++) {
                        var row = this.toPhysicalRow(changes[i][0]);
                        var col = changes[i][1];
                        var oldValue = originData[row][col];
                        // let oldValue = changes[i][2];
                        var newValue = changes[i][3];
                        if (oldValue != newValue && ctrl.gotDirty != true) {
                            ctrl.gotDirty = true;
                            ctrl.$scope.$apply();
                        }
                        else if (ctrl.gotDirty) {
                            ctrl.gotDirty = ctrl.checkDirtiness();
                            ctrl.$scope.$apply();
                        }
                    }
                }
            }
        });
        this.hotTables.push(hot);
        if (divGot == "CUnGMFTable") {
            this.CGMFTable = hot;
        }
    };
    GmfCommercialComponent.prototype.checkDirtiness = function () {
        var dirty = false;
        var tempConfigData = angular.copy(this.configData);
        var configDataForChk = tempConfigData.data.splice(0, tempConfigData.data.length - 1).slice();
        if (configDataForChk.length != this.configData.originData.length) {
            dirty = true;
        }
        if (!dirty) {
            this.tablesData.map(function (td) {
                var data = td.data.Val.Data;
                var originData = td.originData.Val.Data;
                for (var i = 0; i < data.length; i++) {
                    for (var j = 0; j < data[i].length; j++) {
                        if (data[i][j] != originData[i][j]) {
                            dirty = true;
                            break;
                        }
                    }
                }
            });
        }
        //checking dirtiness only if it's still false      
        if (!dirty) {
            var data = configDataForChk;
            var originData = this.configData.originData;
            for (var i = 0; i < data.length; i++) {
                for (var j = 0; j < Object.keys(data[i]).length; j++) {
                    if (data[i][j] != originData[i][j]) {
                        dirty = true;
                        break;
                    }
                }
            }
        }
        return dirty;
    };
    GmfCommercialComponent.prototype.showSummation = function () {
        var ctrl = this;
        var newDiv = document.createElement("div");
        var idCustom = "hotTableActivity";
        newDiv.setAttribute("id", idCustom);
        var currentDiv = document.getElementById("handson-gmf-summary");
        currentDiv.prepend(newDiv);
        var container = document.getElementById(idCustom);
        this.configHotTable = new Handsontable(container, {
            data: this.configData.data,
            rowHeaders: false,
            colHeaders: this.summaryColHeaders,
            colWidths: [50, 40, 70, 80, 50, 30, 50, 50],
            filters: true,
            columnSorting: true,
            dropdownMenu: [
                "filter_by_value",
                "filter_action_bar",
                "filter_by_condition",
            ],
            stretchH: "all",
            height: "auto",
            licenseKey: ctrl.smartorg.handsonTableLicenseKey,
            afterGetColHeader: function (col, TH) {
                TH.className = 'htMiddle htCenter';
            },
            columns: [
                { className: "htCenter htMiddle", readOnly: true },
                { className: "htCenter htMiddle", readOnly: true },
                { className: "htCenter htMiddle", readOnly: true },
                { className: "htCenter htMiddle", readOnly: true },
                { className: "htCenter htMiddle", readOnly: true },
                { className: "htCenter htMiddle", readOnly: true },
                { type: "numeric", className: "htCenter htMiddle", readOnly: true },
                { type: "numeric", className: "htCenter htMiddle", readOnly: true },
            ]
        });
        var hot = this.configHotTable;
        hot.addHook('afterFilter', function (args) {
            var filteredColumns = args.map(function (filter) { return filter.column; });
            ctrl.filterAppliedCols = filteredColumns;
            ctrl.recalcSummation();
        });
        hot.addHook('afterGetColHeader', function (col, TH) {
            var TR = TH.parentNode;
            var THEAD = TR.parentNode;
            var headerLevel = (-1) * THEAD.childNodes.length + Array.prototype.indexOf.call(THEAD.childNodes, TR);
            function applyClass(elem, className) {
                if (!Handsontable.dom.hasClass(elem, className)) {
                    Handsontable.dom.addClass(elem, className);
                }
            }
            // Remove the class 'filter-applied-col' from all columns initially
            Handsontable.dom.removeClass(TH, 'filter-applied-col');
            // Apply the class 'filter-applied-col' to columns with active filters
            if (ctrl.filterAppliedCols && ctrl.filterAppliedCols.includes(col)) {
                applyClass(TH, 'filter-applied-col');
            }
        });
        this.utilsService.handleRenderHandson(hot);
        this.showSummationTotal();
        this.recalcSummation();
    };
    GmfCommercialComponent.prototype.showSummationTotal = function () {
        var ctrl = this;
        var newDiv = document.createElement("div");
        var idCustom = "hotTableActivity2";
        newDiv.setAttribute("id", idCustom);
        var currentDiv = document.getElementById("handson-gmf-summation");
        currentDiv.prepend(newDiv);
        var container = document.getElementById(idCustom);
        var totalRow = ["Total", ctrl.totalFunds, ctrl.totalExpense];
        this.configSummationTable = new Handsontable(container, {
            data: [totalRow],
            rowHeaders: false,
            colWidths: [320, 50, 50],
            filters: true,
            columnSorting: true,
            dropdownMenu: [
                "filter_by_value",
                "filter_action_bar",
                "filter_by_condition",
            ],
            stretchH: "all",
            height: "auto",
            licenseKey: ctrl.smartorg.handsonTableLicenseKey,
            afterGetColHeader: function (col, TH) {
                TH.className = 'htMiddle htCenter';
            },
            columns: [
                {
                    className: "htCenter htMiddle", readOnly: true
                },
                { type: "numeric", className: "htCenter htMiddle", readOnly: true },
                { type: "numeric", className: "htCenter htMiddle", readOnly: true },
            ]
        });
    };
    GmfCommercialComponent.prototype.recalcSummation = function () {
        var ctrl = this;
        this.calcTotal(COL_CONSTS.GMF);
        this.calcTotal(COL_CONSTS.CU);
    };
    GmfCommercialComponent.prototype.calcTotal = function (col) {
        var dataGot = this.configHotTable.getData();
        if (col == COL_CONSTS.GMF) {
            this.totalFunds = dataGot.reduce(function (a, b, idx, src) {
                return (a ? a : 0) + (b[COL_CONSTS.GMF] ? b[COL_CONSTS.GMF] : 0);
            }, 0);
            this.configSummationTable.setDataAtCell(0, 1, this.totalFunds);
        }
        if (col == COL_CONSTS.CU) {
            this.totalExpense = dataGot.reduce(function (a, b, idx, src) {
                return (a ? a : 0) + (b[COL_CONSTS.CU] ? b[COL_CONSTS.CU] : 0);
            }, 0);
            this.configSummationTable.setDataAtCell(0, 2, this.totalExpense);
        }
    };
    GmfCommercialComponent.prototype.deOverride = function () {
        if (!confirm("De-Override will erase all the input data. Do you want to proceed?")) {
            return;
        }
        this.deoverrideInput({
            targetNodeId: this.node._id,
            inputKey: this.tableDef.Key
        });
        this.reset();
    };
    GmfCommercialComponent.prototype.afterSave = function (newComment) {
        var _this = this;
        this.tableInput.data.forEach(function (row) {
            _this.tableInput.colHeaders.forEach(function (h) {
                if (!h.isHeaderColumn) {
                    var cell = row[h.field];
                    cell.originValue = cell.value;
                }
            });
        });
        if (!this.commentHistory) {
            this.commentHistory = [];
        }
        this.commentHistory.push(newComment);
        this.reset();
        this.initComments(this.commentHistory);
    };
    GmfCommercialComponent.prototype.save = function () {
        var _this = this;
        this.saving = true;
        var d = new Date();
        var tables = [];
        var saveOn = d.toDateString().substring(0, d.toDateString().length - 4) +
            d.toTimeString().split(' ')[0] + " " + d.getFullYear();
        this.tablesData.map(function (td, i) {
            var newComment = {
                SavedBy: _this.username,
                SavedOn: saveOn,
                lastVal: __assign({}, td.data.Val, { Data: td.originData.data }),
                msg: _this.currentComment.msg
            };
            var newData = td.data.Val.Data;
            var tableDefCopy = __assign({}, td.data, { Comment: [], Val: __assign({}, td.data.Val, { Data: newData }) });
            tables.push(tableDefCopy);
        });
        var gmfForSave = angular.copy(this.configData);
        var gmfSummationData = gmfForSave.data.splice(0, gmfForSave.data.length - 1).slice();
        this.smartorg.saveMultipleTableInputs(this.node._id, tables, gmfSummationData).then(function (ret) {
            _this.saving = false;
            if (ret && ret.msg && ret.msg.toUpperCase().startsWith('ERROR')) {
                _this.showAlert('danger', "Error!", ret.msg);
            }
            else {
                // this.afterSave(newComment);
                _this.gotDirty = false;
                _this.resetToNew();
                _this.showAlert('success', "Saved!", ret.msg);
                if (_this.commonDataSaveCallback) {
                    _this.commonDataSaveCallback();
                }
                _this.lastUpdated();
            }
        })["catch"](function (err) {
            _this.saving = false;
            _this.showAlert('danger', "Error!", err);
        });
    };
    GmfCommercialComponent.prototype.resetToNew = function () {
        for (var i = 0; i < this.tablesData.length; i++) {
            this.tablesData[i].originData = __assign({}, angular.copy(this.tablesData[i].data), { Val: angular.copy(this.tablesData[i].data.Val) });
        }
        var tempConfData = angular.copy(this.configData);
        var configDataNew = tempConfData.data.splice(0, tempConfData.data.length - 1).slice();
        this.configData = __assign({}, this.configData, { originData: angular.copy(configDataNew) });
    };
    GmfCommercialComponent.prototype.reset = function () {
        for (var i = 0; i < this.tablesData.length; i++) {
            this.tablesData[i].data = __assign({}, angular.copy(this.tablesData[i].originData), { Val: angular.copy(this.tablesData[i].originData.Val) });
            this.hotTables[i].loadData(this.tablesData[i].data.Val.Data);
            this.hotTables[i].render();
        }
        this.configData = __assign({}, this.configData, { data: angular.copy(this.configData.originData) });
        this.configHotTable.loadData(this.configData.data);
        this.configHotTable.alter('insert_row', this.configHotTable.countRows());
        this.recalcSummation();
        this.currentComment.msg = this.currentComment.originMsg;
        this.gotDirty = false;
        // this.$scope.$apply();
    };
    GmfCommercialComponent.prototype.exportCSV = function () {
        return this.tableInput.toCSVCustom('NA', this.configData.data, this.summaryColHeaders);
    };
    GmfCommercialComponent.prototype.exportCSVEU = function () {
        return this.tableInput.toCSVCustom('EU', this.configData.data, this.summaryColHeaders);
    };
    GmfCommercialComponent.prototype.getMenu = function () {
        var ctrl = this;
        return [{
                'name': 'Save',
                'class': 'btn btn-xs btn-danger',
                'show': function () {
                    var dirty = !ctrl.destroyed && ((ctrl.tableInput && ctrl.tableInput.isDirty && ctrl.tableInput.isValid) ||
                        (ctrl.currentComment && ctrl.currentComment.msg !== ctrl.currentComment.originMsg));
                    return ctrl.gotDirty && !ctrl.saving;
                },
                'callback': function () {
                    ctrl.save();
                }
            }, {
                'name': 'Reset',
                'class': 'btn btn-xs btn-primary',
                'show': function () {
                    // const dirty = !ctrl.destroyed && ((ctrl.tableInput && ctrl.tableInput.isDirty) ||
                    //     (ctrl.currentComment && ctrl.currentComment.msg !== ctrl.currentComment.originMsg));
                    // ctrl.setGlobalDirty(dirty);
                    // return !ctrl.saving && dirty;
                    return ctrl.gotDirty && !ctrl.saving;
                },
                'callback': function () {
                    ctrl.reset();
                }
            }, {
                'name': '',
                'class': 'btn btn-xs btn-danger',
                'icon': 'fa fa-spinner fa-spin fa-fw',
                'show': function () {
                    return ctrl.saving;
                }
            }, {
                'name': 'Export',
                'items': [{
                        'name': 'Table',
                        'callback': function () {
                            var csvData = ctrl.exportCSV();
                            Common.downloadCSV(csvData, ctrl.title);
                        }
                    }, {
                        'name': 'Table EU',
                        'callback': function () {
                            var csvData = ctrl.exportCSVEU();
                            Common.downloadCSV(csvData, ctrl.title);
                        }
                    }]
            }];
    };
    return GmfCommercialComponent;
}());
angular.module(COMPONENT_NAME, [
    'ui.grid',
    'ui.grid.pinning',
    'ui.grid.resizeColumns',
    'ui.grid.autoResize',
    'ui.grid.moveColumns',
    'ui.grid.edit',
    'ui.grid.cellNav',
    history_modal_component_1["default"],
    so_rich_text_box_component_1["default"],
]).component('gmfCommercial', {
    template: require('./gmf-commercial.component.html'),
    bindings: {
        smartorg: '=?',
        overrideInput: '&?',
        deoverrideInput: '&?',
        menu: '=',
        isCommonData: '@?',
        commonDataSaveCallback: '&?'
    },
    controller: GmfCommercialComponent
});
exports["default"] = COMPONENT_NAME;
//# sourceMappingURL=gmf-commercial.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/gmf-commercial/gmf-commercial.component.js